// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiComponentRelationTypeSchema = z.enum(['DELEGATES_TO','CALLS_TOOL','CALLS_MCP_TOOL','CALLS_MCP_PROMPT','CALLS_MCP_RESOURCE','CALLS_MCP_PROTOCOL','QUERIES_RAG','USES_MODEL','READS_MEMORY','WRITES_MEMORY','EXPOSES_INTERFACE','REQUIRES_APPROVAL','CROSSES_TRUST_BOUNDARY'] as const);

export type AiComponentRelationTypeType = `${z.infer<typeof AiComponentRelationTypeSchema>}`

export default AiComponentRelationTypeSchema;
